/**
 * This function returns the related option based on level-id.
 * for example when level-id is '1_3_2' it initially gets first level option, then the third option of it and then the second option of that and recursively so on.
 *
 * @param {object} bot - the bot that it should search for
 * @param {string} levelId - identifier for the level that this component should render
 *
 * @return {object} option related to the level-id
 *
 */
export const getOptionBasedOnLevel = (bot, levelId) => {
  const levelIdLength = levelId && levelId.split('_').length

  if (levelIdLength) {
    // current level
    const level = Number(levelId.split('_')[0]) - 1
    const botAccordingToNextLevel = bot.options[level]
    // next level
    const newLevel = levelId.split('_').slice(1).join('_')
    return getOptionBasedOnLevel(botAccordingToNextLevel, newLevel)
  }

  return [bot.question, bot.options]
}
